export const defaultData = [
    {
        row_id: "8",
        items: [
            {
                id: 72,
                item: "Енергія інерції"
            },
            {
                id: 71,
                item: "Енергія руху"
            },
            {
                id: 70,
                item: "Енергія благості"
            },
            {
                id: 69,
                item: "План абсолюту"
            },
            {
                id: 68,
                item: "Космічна свідомість"
            },
            {
                id: 67,
                item: "Космічне благо"
            },
            {
                id: 66,
                item: "План блаженства"
            },
            {
                id: 65,
                item: "План внутрішнього простору"
            },
            {
                id: 64,
                item: "Феноме<wbr/>нальний план"
            }
        ]
    },
    {
        row_id: "7",
        items: [
            {
                id: 55,
                item: "Егоїзм"
            },
            {
                id: 56,
                item: "Звук"
            },
            {
                id: 57,
                item: "План повітря"
            },
            {
                id: 58,
                item: "Сяяння"
            },
            {
                id: 59,
                item: "План реальності"
            },
            {
                id: 60,
                item: "Вірно направлена свідомість"
            },
            {
                id: 61,
                item: "Невірно направлена свідомість"
            },
            {
                id: 62,
                item: "Щастя"
            },
            {
                id: 63,
                item: "Інерція"
            }
        ]
    },
    {
        row_id: "6",
        items: [
            {
                id: 54,
                item: "Духовна відданість"
            },
            {
                id: 53,
                item: "Вода"
            },
            {
                id: 52,
                item: "Насилля"
            },
            {
                id: 51,
                item: "Земля"
            },
            {
                id: 50,
                item: "Аскетизм"
            },
            {
                id: 49,
                item: "Місячний план"
            },
            {
                id: 48,
                item: "Сонячний план"
            },
            {
                id: 47,
                item: "План нейтраль<wbr/>ності"
            },
            {
                id: 46,
                item: "Інтуіція"
            }
        ]
    },
    {
        row_id: "5",
        items: [
            {
                id: 37,
                item: "Мудрість"
            },
            {
                id: 38,
                item: "Енергія"
            },
            {
                id: 39,
                item: "Відпуска<wbr/>ння"
            },
            {
                id: 40,
                item: "Енергетична цілісність"
            },
            {
                id: 41,
                item: "Свобода реалізації"
            },
            {
                id: 42,
                item: "Вогонь"
            },
            {
                id: 43,
                item: "Народження нової людини"
            },
            {
                id: 44,
                item: "Незнання"
            },
            {
                id: 45,
                item: "Правильне знання"
            }
        ]
    },
    {
        row_id: "4",
        items: [
            {
                id: 36,
                item: "Чистота"
            },
            {
                id: 35,
                item: "Чистилище"
            },
            {
                id: 34,
                item: "План смаку"
            },
            {
                id: 33,
                item: "План ароматів"
            },
            {
                id: 32,
                item: "План рівноваги"
            },
            {
                id: 31,
                item: "Зустріч з учителем"
            },
            {
                id: 30,
                item: "Хороші тенденції"
            },
            {
                id: 29,
                item: "Запере<wbr/>чення власної природи"
            },
            {
                id: 28,
                item: "Прийняття власної природи"
            }
        ]
    },
    {
        row_id: "3",
        items: [
            {
                id: 19,
                item: "Карма"
            },
            {
                id: 20,
                item: "Благодій<wbr/>ність"
            },
            {
                id: 21,
                item: "Виправ<wbr/>лення"
            },
            {
                id: 22,
                item: "Закони світо<wbr/>будови"
            },
            {
                id: 23,
                item: "Впевненість"
            },
            {
                id: 24,
                item: "Погана компанія"
            },
            {
                id: 25,
                item: "Хороша компанія"
            },
            {
                id: 26,
                item: "Печаль"
            },
            {
                id: 27,
                item: "Вища ціль"
            }
        ]
    },
    {
        row_id: "2",
        items: [
            {
                id: 18,
                item: "Радість"
            },
            {
                id: 17,
                item: "Співчуття"
            },
            {
                id: 16,
                item: "Ревнощі"
            },
            {
                id: 15,
                item: "План фантазій"
            },
            {
                id: 14,
                item: "Зв'язок"
            },
            {
                id: 13,
                item: "Нікчем<wbr/>ність"
            },
            {
                id: 12,
                item: "Заздрість"
            },
            {
                id: 11,
                item: "Розвага"
            },
            {
                id: 10,
                item: "Очищення"
            }
        ]
    },
    {
        row_id: "1",
        items: [
            {
                id: 1,
                item: "Народ<wbr/>ження"
            },
            {
                id: 2,
                item: "Ілюзія"
            },
            {
                id: 3,
                item: "Гнів"
            },
            {
                id: 4,
                item: "Хотіння"
            },
            {
                id: 5,
                item: "Рід",
                text: "Потреба у почутті опори, безпеки, компфорту. Матеріальний світ. Земля пов'язана з родом і корінням. "
            },
            {
                id: 6,
                item: "Омана"
            },
            {
                id: 7,
                item: "Марнослав<wbr/>ство"
            },
            {
                id: 8,
                item: "Невдово<wbr/>лення"
            },
            {
                id: 9,
                item: "Чуттєвий досвід"
            }
        ]
    }
];